export default {
  navigation: {
    next: "Далее",
    back: "Назад",
    surveyNavigation: "Навигация по опросу",
    workspace: {
      home: "Главная",
      example: "Пример"
    }
  }
}
